import {
    CREATE_IRONING_AND_PACKING_INWARD_FAILURE,
    CREATE_IRONING_AND_PACKING_INWARD_REQUEST,
    CREATE_IRONING_AND_PACKING_INWARD_SUCCESS,
    CREATE_USER_FORM_IRONING_AND_PACKING_INWARD,
    FETCH_SINGLE_IRONING_AND_PACKING_INWARD_FAILURE,
    FETCH_SINGLE_IRONING_AND_PACKING_INWARD_REQUEST,
    FETCH_SINGLE_IRONING_AND_PACKING_INWARD_SUCCESS,
    FETCH_IRONING_AND_PACKING_INWARD_FAILURE,
    FETCH_IRONING_AND_PACKING_INWARD_REQUEST,
    FETCH_IRONING_AND_PACKING_INWARD_SUCCESS,
    NAVIGATE_IRONING_AND_PACKING_INWARD_DETAILS,
    NAVIGATE_IRONING_AND_PACKING_INWARD,
    IRONING_AND_PACKING_INWARD_USERFORM_RESET,
    UPDATE_IRONING_AND_PACKING_INWARD_FAILURE,
    UPDATE_IRONING_AND_PACKING_INWARD_REQUEST,
    UPDATE_IRONING_AND_PACKING_INWARD_SUCCESS,
    DELETE_IRONING_AND_PACKING_INWARD_REQUEST,
    DELETE_IRONING_AND_PACKING_INWARD_SUCCESS,
    DELETE_IRONING_AND_PACKING_INWARD_FAILURE,
    FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_IRONING_AND_PACKING_INWARD,
    RESET_FORM_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID,
    SET_END_DATE_IRONING_AND_PACKING_INWARD,
    SET_START_DATE_IRONING_AND_PACKING_INWARD,
    SET_UNIT_NAME_IRONING_AND_PACKING_INWARD,
    FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_SUCCESS,
    FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_FAILURE,
    FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_REQUEST,
    FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_REQUEST,
    FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_SUCCESS,
    FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_FAILURE
} from './ironingAndPackingInward.actionsType';

export const IRONING_AND_PACKING_INWARD = 'ironingAndPackingInward';

let initialState = {
    loading: false,
    ironingAndPackingInward: [],
    pendingIroningAndPackingDC: [],
    activeKey: 1,
    ironingAndPackingInwardId: '',
    ironingAndPackingInwardMasterForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null,

        fldRoundoff: 0
    },
    selectedIroningAndPackingInward: {},
    isIroningAndPackingInward: false,
    ironingAndPackingInwardSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    isRender: false,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),
    checkEANExits: '',
};

export let ironingAndPackingInwardReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_IRONING_AND_PACKING_INWARD_REQUEST:
        case FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_REQUEST:
        case CREATE_IRONING_AND_PACKING_INWARD_REQUEST:
        case FETCH_SINGLE_IRONING_AND_PACKING_INWARD_REQUEST:
        case UPDATE_IRONING_AND_PACKING_INWARD_REQUEST:
        case DELETE_IRONING_AND_PACKING_INWARD_REQUEST:
        case FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_REQUEST:
        case FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_AND_PACKING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInward: updatePayload
            };
        case FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingIroningAndPackingDC: updatePayload
            };
        case CREATE_IRONING_AND_PACKING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                ironingAndPackingInwardId: updatePayload[0],
                activeKey: updatePayload[0]?.fldID && payload == true ? 2 : 1
            };
        case FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                packedQTYAgainstSalesOrder: updatePayload
            }
        case FETCH_SINGLE_IRONING_AND_PACKING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningAndPackingInward: updatePayload,
                ironingAndPackingInwardMasterForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case UPDATE_IRONING_AND_PACKING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedIroningAndPackingInward: {},
                ironingAndPackingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,
                    fldRoundoff: 0
                }
            };
        case DELETE_IRONING_AND_PACKING_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedIroningAndPackingInward: {}
            };
        case FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_SUCCESS:
            return {
                ...state,
                loading: false,
                checkEANExits: updatePayload
            };
        case FETCH_IRONING_AND_PACKING_INWARD_FAILURE:
        case FETCH_PENDING_IRONING_AND_PACKING_PO_IN_INWARD_FAILURE:
        case FETCH_SINGLE_IRONING_AND_PACKING_INWARD_FAILURE:
        case CREATE_IRONING_AND_PACKING_INWARD_FAILURE:
        case UPDATE_IRONING_AND_PACKING_INWARD_FAILURE:
        case DELETE_IRONING_AND_PACKING_INWARD_FAILURE:
        case FETCH_PACKED_QTY_AGAINST_SALES_ORDER_OF_IP_INWARD_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_IRONING_AND_PACKING_INWARD:
            return {
                ...state,
                loading: false,
                ironingAndPackingInwardMasterForm: {
                    ...state.ironingAndPackingInwardMasterForm,
                    [payload.key]: payload.value
                }
            };
        case SET_ACTIVE_KEY_IRONING_AND_PACKING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case IRONING_AND_PACKING_INWARD_USERFORM_RESET:
            return {
                ...state,
                ironingAndPackingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedIroningAndPackingInward: {},
                ironingAndPackingInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_IRONING_AND_PACKING_INWARD_ID:
            return {
                ...state,
                ironingAndPackingInwardMasterForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null,

                    fldRoundoff: 0
                },
                selectedTeam: {}
            };
        case NAVIGATE_IRONING_AND_PACKING_INWARD_DETAILS:
            return {
                ...state,
                isIroningAndPackingInward: true,
                ironingAndPackingInwardSelectedValue: updatePayload.ironingAndPackingInwardSelectedValue
            };
        case NAVIGATE_IRONING_AND_PACKING_INWARD:
            return {
                ...state,
                isIroningAndPackingInward: false,
                isRender: true,
            };
        case SET_UNIT_NAME_IRONING_AND_PACKING_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_IRONING_AND_PACKING_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_IRONING_AND_PACKING_INWARD:
            return {
                ...state,
                endDate: payload
            };
        case FETCH_IRONING_AND_PACKING_INWARD_EAN_EXISTS_FAILURE:
            return {
                ...state,
                loading: false,
                checkEANExits: updatePayload,
                activeKey: 1
            };
        default:
            return state;
    }
};
